import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {loadProject} from "../components/project/one-project/projectAction";
import WelcomeSection from "../components/guided-update/guided-update-project/WelcomeSection";
import MyTeam from "../components/guided-update/guided-update-project/team/MyTeam";
import EvaluationSection from "../components/guided-update/guided-update-project/EvaluationSection";
import ObjectivesSection from "../components/guided-update/guided-update-project/ObjectivesSection";
import PitchProject from "../components/project/pitch/PitchProject";
import ActionsSection from "../components/guided-update/guided-update-project/ActionsSection";
import FunctionalSection from "../components/guided-update/guided-update-project/FunctionalSection";
import {CLEAR_PROJECT} from "../components/project/actionsType";
import {useParams} from "react-router";
import SwotSection from "../components/guided-update/guided-update-project/SwotSection";
import KanbanSection from "../components/guided-update/guided-update-project/KanbanSection";
import UpdateProject from "../components/project/one-project/update/UpdateProject";
import UpdateProjectSection from "../components/guided-update/guided-update-project/UpdateProjectSection";

const GuidedUpdateProjectPage = () => {


    const {id} = useParams()
    const dispatch = useDispatch();

    useEffect(() => {
            dispatch({type: CLEAR_PROJECT})
    }, [dispatch])

    const [count, setCount] = useState(1);
    const {isLoading} = useSelector((state) => state.project);
    const maxCount=8
    const minCount=0

    const displaySection = (count) => {
        switch (count) {
            case 0:
                return <UpdateProjectSection setCount={setCount}/>
            case 1 :
                return <WelcomeSection toggleHandler={toggleHandler}/>
            case 2 :
                return <SwotSection toggleHandler={toggleHandler}/>
            case 3:
                return <MyTeam toggleHandler={toggleHandler}/>
            case 4:
                return <KanbanSection toggleHandler={toggleHandler} />
            case 5:
                return <ObjectivesSection isLoading={isLoading} toggleHandler={toggleHandler} isInteractive={true}/>
            case 6 :
                return <ActionsSection toggleHandler={toggleHandler}/>
            case 7:
                return <EvaluationSection toggleHandler={toggleHandler} inEvaluationSection={true}/>
            case 8:
                return <PitchProject toggleHandler={toggleHandler} fromGuidedUpdate={true}/>
            default:
                //TODO : create component for this error !
                return <p> Oups, une erreur s'est produite ... </p>
        }
    }

    useEffect(() => {
        dispatch(loadProject(id));
    }, [dispatch, id])


    const toggleHandler = async (direction) => {
        if (direction === 'next') {
            setCount(count + 1);
        } else if (direction === 'prev') {
            setCount(count - 1);
        }
    }

    return (
        <FunctionalSection
            component={displaySection(count)}
            minCount={minCount}
            maxCount={maxCount}
            count={count}
            setCount={setCount}
        />
    )
}

export default GuidedUpdateProjectPage;

